import React, { useContext } from 'react'
import { JourneyContext } from '../context/journeyContext'
import DOMPurify from 'dompurify'


export default function ComponentTextParagraph(props) {
   const [journeyState, setJourneyState] = useContext(JourneyContext)
   const sanitizedContent = DOMPurify.sanitize(props.data.Content);

       // don't render canara hsbc employee field if the journey is of type broker
  if (journeyState.journeyType === "Broker" && props.data.formControlKey === "employeeOfBank"){
    return null;
  }

  
    return (
         <>
            <label className="inp-label">
            </label>
            <div dangerouslySetInnerHTML={{"__html":sanitizedContent}}></div>
         </>
        )

}
